import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: fixed;
  top: 15px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  background-color: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 1px 3px 3px rgba(0, 0, 0, 0.05);
  width: 90%;
  max-width: 350px;
`;

export const Header = styled.div`
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
`;

export const Progress = styled.div`
  width: 100%;
  height: 3px;
  background-color: #f0f0f0;
  position: relative;
  margin: 15px 0 25px;
`;

export const Bar = styled.div`
  background-color: ${({ theme }) => theme.palette.base};
  position: absolute;
  left: 0;
  top: 0;
  height: 3px;
`;

export const Text = styled.div`
  text-align: center;
  font-weight: 300;
  font-size: 13px;
  position: absolute;
  top: 13px;
  width: 100%;
`;
